import { identifyDeviceType } from '@cian/utils';
import { createMapTelemetry } from './createMapTelemetry';
import { setMapTelemetry } from './registry';

import type { IApplicationContext } from 'shared/map-search/types/applicationContext';

/**
 * Кладёт фасад телеметрии карты в реестр на старте приложения.
 *
 * Тип устройства берём из userAgent, а не из React-хука: фасад нужен слою пинов,
 * который живёт вне дерева компонентов и обращается к реестру напрямую.
 */
export function initMapTelemetry(context: IApplicationContext) {
  setMapTelemetry(
    createMapTelemetry({
      telemetry: context.telemetry,
      logger: context.logger,
      config: context.config,
      deviceType: identifyDeviceType(navigator.userAgent),
    }),
  );
}
